import { render, staticRenderFns } from "./CoursewareRibbon.vue?vue&type=template&id=9a134ea6&"
import script from "./CoursewareRibbon.vue?vue&type=script&lang=js&"
export * from "./CoursewareRibbon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/moritz/html/v5.3-jlu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a134ea6')) {
      api.createRecord('9a134ea6', component.options)
    } else {
      api.reload('9a134ea6', component.options)
    }
    module.hot.accept("./CoursewareRibbon.vue?vue&type=template&id=9a134ea6&", function () {
      api.rerender('9a134ea6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/courseware/CoursewareRibbon.vue"
export default component.exports